var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubDivisionItemCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4218_13250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0675 6.18741C17.6707 5.08776 17.0473 4.08378 16.2376 3.24058C15.4278 2.39738 14.4499 1.73379 13.3672 1.29286C12.2845 0.851926 11.1212 0.64349 9.95278 0.681069C8.78434 0.718648 7.63685 1.0014 6.58473 1.511C5.5326 2.02059 4.59934 2.74564 3.84546 3.63913C3.09158 4.53261 2.53392 5.57458 2.20865 6.69746C1.88338 7.82034 1.79776 8.99905 1.95734 10.1571C2.11693 11.3152 2.51816 12.4269 3.135 13.4199L0.6875 18.5624L5.83 16.1149C6.77779 16.7046 7.83463 17.0974 8.9375 17.2699",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 6.1875H12.6042",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 10.3125H8.47917",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9775 8.64455C17.0012 8.642 18.0038 8.93502 18.865 9.4884C19.7261 10.0418 20.4092 10.832 20.8322 11.7642C21.2552 12.6963 21.4002 13.7308 21.2496 14.7433C21.099 15.7558 20.6593 16.7033 19.9833 17.472L20.6434 21.3129L17.1692 19.1679C16.7791 19.2634 16.3791 19.3126 15.9775 19.3145C14.5626 19.3145 13.2056 18.7525 12.2051 17.752C11.2046 16.7515 10.6425 15.3945 10.6425 13.9795C10.6425 12.5646 11.2046 11.2076 12.2051 10.2071C13.2056 9.20663 14.5626 8.64455 15.9775 8.64455V8.64455Z",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 13.9795H14.2084",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4218_13250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubDivisionItemCommentIcon);
export default __webpack_public_path__ + "static/media/sub-division-item-comment-icon.c950d9afe32e7b96eaccc1c08c26276f.svg";
export { ForwardRef as ReactComponent };